import React, { useId } from 'react';
import { IMPORT_JSON_MESSAGES } from './messages';

interface ImportJsonPanelProps {
  value: string;
  onChange: (text: string) => void;
  onApply: () => void;
  error?: string;
}

export function ImportJsonPanel({
  value, onChange, onApply, error,
}: ImportJsonPanelProps) {
  const textareaId = useId();

  return (
    <div className="card mb-3">
      <div className="card-body">
        <textarea
          id={textareaId}
          className="form-control form-control-sm border border-secondary"
          rows={6}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        {error && <div className="text-danger small mt-1">{error}</div>}
        <div className="mt-2">
          <button type="button" className="btn btn-sm btn-primary" onClick={onApply}>
            {IMPORT_JSON_MESSAGES.applyButton}
          </button>
        </div>
      </div>
    </div>
  );
}
